import React, { useEffect } from "react";
import "./style.scss";
import errorModalIcon from "../../assets/icons/error-modal-icon.png";
import warningIcon from "../../assets/icons/warning (4).png";
import { useNavigate } from "react-router-dom";

const ErrorModal = ({ msg, route, warning, btnText = "Try Again" }) => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleClose = (e) => {
    if (e) e.preventDefault();
    setOpen(false);
    if (route) {
      navigate(route);
    }
  };

  useEffect(() => {
    setOpen(true);
  }, []);

  return msg && open ? (
    <div className="error-modal-overlay">
      <div className="error-modal-container">
        <div className="error-modal-icon">
          <img src={warning ? warningIcon : errorModalIcon} alt="" />
        </div>
        <div className="error-modal-info">
          <h2 className="modal-name">{warning ? "Warning!" : "Error!"}</h2>
          <p className="modal-description">
            Oh no<br></br>
            {msg}
          </p>
        </div>
        <div className="error-modal-button">
          <button
            onClick={() => handleClose()}
            className="modal-button"
            style={{ backgroundColor: warning && "#ffc048" }}
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  ) : (
    false
  );
};

export default ErrorModal;
